<template>
  <v-container style="height: 100%" fluid class="pa-0">
    <ag-grid-vue
      :style="{ width, height }"
      class="ag-theme-alpine"
      :defaultColDef="defaultColDef"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :animateRows="true"
      :rowBuffer="rowBuffer"
      :paginationAutoPageSize="paginationAutoPageSize"
      :pagination="pagination"
      :isExternalFilterPresent="isExternalFilterPresent"
      :doesExternalFilterPass="externalFilter"
      :paginationPageSize="paginationPageSize"
      rowSelection="multiple"
      :rowDeselection="true"
      @grid-ready="onGridReady"
      @cellDoubleClicked="onCellDoubleClick"
      @filterChanged="$emit('gridModelChanged', gridApi.getModel())"
    ></ag-grid-vue>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import moment from "moment";

export default {
  components: {
    AgGridVue,
  },
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      agGridData: "agGrid/gridData",
    }),
  },
  props: [
    "agGridDataLoading",
    "columnDefs",
    "search",
    "searchTimeout",
    "externalFilter",
    "filterObject",
    "isExternalFilterPresent",
    "rowBuffer",
    "pagination",
    "paginationAutoPageSize",
    "paginationPageSize",
    "endpoint",
  ],
  data: () => ({
    // AG-Grid
    rowData: null,
    columnApi: null,
    gridApi: null,
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      autoHeight: true,
      filterParams: { newRowsAction: "keep" },
    },
    width: "100%",
    height: "100%",
    searchDebounce: null,
  }),
  watch: {
    agGridData: function(newData, oldData) {
      if (this.agGridData.length > 0 && this.gridApi != null) {
        this.setGridData();
      }
    },
    search: function() {
      this.onQuickFilterChanged();
    },
    columnDefs: function() {
      this.loadGridData();
    },
    endpoint: function() {},
  },
  mounted() {
    if (this.columnDefs != null) {
      this.$store.dispatch("agGrid/loadGridData", {
        columnDefs: this.columnDefs,
        endpoint: this.endpoint,
      });
    }

    // if (this.agGridData.length > 0 && this.gridApi != null) {
    //   this.setGridData();
    // }
  },
  methods: {
    loadGridData() {
      if (this.gridApi != null) {
        this.gridApi.showLoadingOverlay();
      }
      this.$store.dispatch("agGrid/loadGridData", {
        columnDefs: this.columnDefs,
        endpoint: this.endpoint,
      });
    },
    setGridData() {
      this.gridApi.showLoadingOverlay();

      const rowData = this.agGridData;
      this.gridApi.setRowData(rowData);
      setTimeout(() => {
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function(column) {
          if (column.colDef.suppressSizeToFit != true) {
            allColumnIds.push(column.colId);
          }
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
        this.$emit("gridModelChanged", this.gridApi.getModel());
      }, 50);
    },
    onQuickFilterChanged() {
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.gridApi.setQuickFilter(this.search);
      }, this.searchTimeout);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.showLoadingOverlay();

      if (this.agGridData.length > 0) {
        setTimeout(() => {
          this.setGridData();
        }, 200);
      }
    },
    autoSizeColumnsAGGRID() {
      // this.gridApi.sizeColumnsToFit();
      var allColumnIds = [];
      this.columnApi.getAllColumns().forEach(function(column) {
        allColumnIds.push(column.colId);
      });
      this.columnApi.autoSizeColumns(allColumnIds, false);
    },
    onCellDoubleClick(cell) {
      this.$emit("cellDoubleClick", cell);
    },
    getSelectedRows() {
      return this.gridApi.getSelectedRows();
    },
    updateFilter() {
      this.gridApi.onFilterChanged();
    },
    resetFilters() {
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
    },
  },
};
window.hasImageFormatter = function hasImageFormatter(params) {
  if (params.data.hasImage == 1) {
    return true;
  } else {
    return false;
  }
};
window.roleFormatter = function roleFormatter(params) {
  switch (params.data.role) {
    case "superAdmin":
      return "Admin";
      break;
    case "technician":
      return "Technician";
      break;
    case "customer":
      return "Customer";
      break;
    default:
      return "";
      break;
  }
};
window.created_atFormatter = function created_atFormatter(params) {
  return moment
    .utc(params.data.created_at)
    .local()
    .format("MMMM Do YYYY, h:mm:ss a");
};
window.updated_atFormatter = function updated_atFormatter(params) {
  return moment
    .utc(params.data.updated_at)
    .local()
    .format("MMMM Do YYYY, h:mm:ss a");
};
</script>

<style>
.croppa-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.croppa-container canvas {
  border: 1px solid;
}
</style>
